// signaling Edge 함수 호출 (anon overlay 전용).
//  인증 = broadcast_token(body) — JWT 없음. apikey 헤더만 동봉(verify_jwt=false).
//  "이벤트 스트림을 받기 위한 준비"만 = 세션 발급(session) + 구독(subscribe). 스트림 자체는 브라우저 직결.
const FUNCTIONS_URL = `${process.env.VUE_APP_SUPABASE_URL}/functions/v1`;

async function callSignaling(path, body) {
  const res = await fetch(`${FUNCTIONS_URL}${path}`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      apikey: process.env.VUE_APP_SUPABASE_KEY,
    },
    body: JSON.stringify(body || {}),
  });
  const json = await res.json().catch(() => ({}));
  if (!res.ok) {
    throw Object.assign(new Error(json.message || "E_SIGNALING_FAILED"), { status: res.status, detail: json });
  }
  return json;
}

export default {
  // broadcast_token → { petId, ownerId, email }. 신원 해석(게이트웨이 무관) → 모델/데이터 로드의 시작점.
  async identity(token) {
    return await callSignaling("/signaling/identity", { token });
  },
  // broadcast_token → ephemeral 세션 url. 미연동이면 status 409 (E_CHZZK_NOT_CONNECTED) throw.
  async chzzkSession(token) {
    const { url } = await callSignaling("/signaling/chzzk/event-stream/session", { token });
    return url;
  },
  // 브라우저가 직결 후 받은 sessionKey로 이벤트 구독 (서버가 OAuth로 대신). kinds 기본 chat.
  async chzzkSubscribe(token, sessionKey, kinds = ["chat", "donation", "subscription"]) {
    const { results } = await callSignaling("/signaling/chzzk/event-stream/subscribe", { token, sessionKey, kinds });
    return results;
  },
};
